<template>
  <div id="modal-login">
    <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">

            <div
              v-if="forgotPassword"
              class="modal-content"
              role="dialog"
              aria-labelledby="forgotPasswordTitle"
            >
              <button class="close-btn-modal" @click="$emit('close')" aria-label="Fermer"></button>
              <div class="modal-content-form">
                <div class="header-modal">
                  <h1 id="forgotPasswordTitle" class="merriweather-reg-26">Mot de passe oublié</h1>
                </div>
                <div v-if="sent" class="form-signup raleway-reg-p15">
                  <div class="form-item">
                    <p>Nous venons d’envoyer un e-mail contenant des instructions ainsi qu’un lien pour réinitialiser votre mot de passe à l’adresse {{this.forgotMail}}. Il est possible que vous deviez patienter quelques minutes avant de le recevoir.</p>
                  </div>
                  <button @click="$emit('close')" class="hortense-btn-primary">Retour à l'accueil</button>
                </div>

                <form v-else class="form-signup raleway-reg-p15" @submit.prevent="sendForget" autocomplete="email">
                  <div class="form-item full-width">
                    <label for="forgot_email">Saisissez votre adresse email</label>
                    <div class="input-wrapper">
                      <input
                        id="forgot_email"
                        v-model="forgotMail"
                        type="email"
                        name="email"
                        autocomplete="email"
                        placeholder="marie@exemple.fr"
                      >
                    </div>
                  </div>
                  <div>
                  </div>
                  <button type="submit" class="hortense-btn-primary" :disabled="isSendingReset">
                    {{ isSendingReset ? "Envoi en cours..." : "Envoyer le lien de réinitialisation" }}
                  </button>
                </form>
              </div>

            </div>
            <div
              v-else
              class="modal-content"
              role="dialog"
              aria-labelledby="loginTitle"
            >
              <button class="close-btn-modal" @click="$emit('close')" aria-label="Fermer"></button>
              <div class="modal-content-form">
                <div class="header-modal">
                  <h1 id="loginTitle" class="merriweather-reg-26">Mon compte</h1>
                </div>
                <form class="form-signup raleway-reg-p15" @submit.prevent="UserBasicInfo" autocomplete="on">
                  <p class="form-error raleway-semi-p15" v-if="errorMessage" aria-live="polite"><span class="error-icon">⚠</span> E-mail ou mot de passe invalide</p>
                  <div class="form-item full-width">
                    <label for="login_email">Email</label>
                    <div class="input-wrapper">
                      <input
                        id="login_email"
                        ref="firstInput"
                        v-model="userInfo.email"
                        type="email"
                        name="email"
                        autocomplete="email"
                        placeholder="marie@exemple.fr"
                      >
                    </div>
                  </div>
                  <div class="form-item full-width">
                    <label for="login_password">Mot de passe</label>
                    <div class="input-wrapper">
                      <input
                        id="login_password"
                        v-model="userInfo.password"
                        type="password"
                        name="password"
                        autocomplete="current-password"
                        placeholder="............"
                      >
                    </div>
                  </div>
                  <a @click="forgotPassword = true" class="link-hortense forgot-link mb-4">Mot de passe oublié?</a>
                  <button type="submit" class="hortense-btn-primary" :disabled="isSubmitting">
                    {{ isSubmitting ? "Connexion en cours..." : "Me connecter" }}
                  </button>
                </form>
              </div>
              <div class="social-divider"><span>ou se connecter avec</span></div>
              <div class="social-connection-btn">
                <a href="/users/auth/google_oauth2" class="social-btn" @click="pushLoginEvent('google')">
                  <img src="https://hortense-vue.s3.eu-west-3.amazonaws.com/static/google.png" alt="" aria-hidden="true" v-set-alt> Google
                </a>
                <a href="/users/auth/facebook" class="social-btn" @click="pushLoginEvent('facebook')">
                  <img src="https://hortense-vue.s3.eu-west-3.amazonaws.com/static/facebook.png" alt="" aria-hidden="true" v-set-alt> Facebook
                </a>
              </div>
            </div>
          </div>
        </div>
      </transition>
  </div>
</template>

<script>
    import fetcher from 'packs/shared/api.js';

  export default{
    name: 'modal-login',
    data() {
      return {
        userInfo: {
          email: '',
          password: ''
        },
        showModal: false,
        errorMessage: false,
        forgotPassword: false,
        forgotMail: '',
        sent: false,
        isSubmitting: false,
        isSendingReset: false
      };
    },
    beforeDestroy() {
      const whatsappBtn = document.getElementById('whatsapp-button');
      if (whatsappBtn) {
        whatsappBtn.style.display = 'block';
      }
      document.querySelectorAll('.fixed-banner').forEach(el => {
        el.style.zIndex = '';
      });
      document.querySelectorAll('.fixed-bannertwo').forEach(el => {
        el.style.zIndex = '';
      });
      
      // Re-enable body scroll on mobile
      if (this.isPhone()) {
        document.body.style.overflow = '';
      }
    },
    mounted() {
      const whatsappBtn = document.getElementById('whatsapp-button');
      if (whatsappBtn) {
        whatsappBtn.style.display = 'none';
      }

      document.querySelectorAll('.fixed-banner').forEach(el => {
        el.style.zIndex = '1';
      });

      document.querySelectorAll('.fixed-bannertwo').forEach(el => {
        el.style.zIndex = '1';
      });
      
      // Focus on first input field
      this.$nextTick(() => {
        if (this.$refs.firstInput) {
          this.$refs.firstInput.focus();
        }
      });
      
      // Block body scroll on mobile
      if (this.isPhone()) {
        document.body.style.overflow = 'hidden';
      }
    },
    methods: {
      isPhone() {
        return window.innerWidth <= 480;
      },
      pushLoginEvent(method) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'login',
          method: method,
        });
      },
      async UserBasicInfo(){
        if (this.isSubmitting) {
          return;
        }

        this.errorMessage = false;
        this.isSubmitting = true;

        try {
          const res = await fetcher.post('/users/sign_in', {
            user: {
              email: this.userInfo.email,
              password: this.userInfo.password,
              role: 'customer'
            }
          })
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'login',
            method: 'email_password',
          });
          if (res.data.redirect_to_otp) {
            window.location.href = '/user/otp';
          } else {
            this.$emit('close', res.data)
            location.reload();
          }
        } catch(e) {
          this.errorMessage = true;
        } finally {
          this.isSubmitting = false;
        }
      },
      async sendForget(){
        if (this.isSendingReset) {
          return;
        }

        this.isSendingReset = true;

        try {
          const res = await fetcher.post('/send-reset-password', {
            email: this.forgotMail
          })
          console.log(res)
        } catch(e){
          console.log(e)
        }
        this.sent = true
        this.isSendingReset = false;
      },
      setUser(user){
        this.user = user;
        this.showModallogin = false;
      },
    },
  }
</script>

<style lang="scss" scoped>
.close-btn-modal {
  position: absolute;
  top: 1rem;
  right: 1.25rem;
  background: none;
  border: none;
  font-size: 1.75rem;
  line-height: 1;
  color: #555;
  cursor: pointer;
  z-index: 10;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  transition: color 0.2s, background 0.2s;

  &:hover { color: #3B6152; background: rgba(59,97,82,0.08); }
}

.modal-mask {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001 !important;
  overflow-y: auto;
}

.modal-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.modal-content {
  position: relative;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.18);
  width: 100%;
  max-width: 680px;
  overflow: hidden;
  animation: modalIn 0.25s ease;

  @media (max-width: 768px) {
    max-width: 100%;
    border-radius: 0;
    min-height: 100vh;
  }
}

@keyframes modalIn {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

.modal-content-form {
  padding: 3rem 3.5rem 1.5rem;
  overflow-y: auto;
  max-height: 90vh;

  @media (max-width: 768px) {
    padding: 2.5rem 1.25rem 1.25rem;
    max-height: none;
  }
}

.header-modal {
  margin-bottom: 1.25rem;

  h1 { margin: 0 0 0.2rem; }
}

.form-signup {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem;

  .form-item.full-width { width: 100%; }
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;

  label {
    font-size: 0.82rem;
    font-weight: 600;
    color: #333;
    letter-spacing: 0.01em;
    margin: 0;
  }

  .input-wrapper {
    position: relative;
    display: flex;
    align-items: center;

    input {
      width: 100%;
      padding: 0.65rem 0.85rem;
      border: 1.5px solid #d0d0d0;
      border-radius: 6px;
      font-size: 0.9rem;
      font-family: inherit;
      background: #fafafa;
      transition: border-color 0.2s, box-shadow 0.2s;
      box-sizing: border-box;

      &:focus {
        outline: none;
        border-color: #3B6152;
        background: #fff;
        box-shadow: 0 0 0 3px rgba(59,97,82,0.12);
      }

      &::placeholder { color: #bbb; font-size: 0.85rem; }
    }
  }
}

.form-error {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  color: #e74c3c;
  font-size: 0.82rem;
  background: #fff3f3;
  border: 1px solid #ffd0d0;
  border-radius: 6px;
  padding: 0.45rem 0.75rem;
  width: 100%;

  .error-icon { font-size: 0.9rem; }
}

.forgot-link {
  cursor: pointer;
  text-align: center;
  margin: 0;
}

button.hortense-btn-primary {
  width: 100%;
  max-width: 320px;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border: 0;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.04em;
  transition: opacity 0.2s, transform 0.15s;
  align-self: center;

  &:hover:not([disabled]) { transform: translateY(-1px); }
  &[disabled] { opacity: 0.6; cursor: not-allowed; }
}

.social-divider {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0 0.5rem;
  color: #aaa;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;

  &::before, &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e9ecef;
  }
}

.social-connection-btn {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  padding-bottom: 1.5rem;

  .social-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex: 1;
    max-width: 180px;
    justify-content: center;
    border: 1.5px solid #e0e0e0;
    border-radius: 8px;
    padding: 0.6rem 1rem;
    text-decoration: none;
    color: #444;
    font-size: 0.88rem;
    font-weight: 500;
    transition: border-color 0.2s, box-shadow 0.2s, transform 0.15s;
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
      object-fit: contain;
      flex-shrink: 0;
    }

    &:hover {
      border-color: #3B6152;
      box-shadow: 0 2px 8px rgba(59,97,82,0.12);
      transform: translateY(-1px);
      color: #3B6152;
    }
  }
}

.link-hortense {
  color: #3B6152;
  cursor: pointer;
  font-weight: 600;
  transition: color 0.2s;
  text-decoration: none;

  &:hover { color: #2d4a3d; text-decoration: underline; }
}

.modal-enter-active, .modal-leave-active { transition: opacity 0.25s ease; }
.modal-enter, .modal-leave-to { opacity: 0; }
</style>
